// import React from 'react';
import { BrowserRouter as Router, Route, Link, Routes } from 'react-router-dom';
// import Home from './Home';
import About from './About';
// import { Link } from 'react-router-dom';
import { AppContext } from './context/AppContext';

import { useContext, useState, useEffect } from 'react';
import PenaltyDisplay from './PenaltyDisplay';
// import './App.css';
import Main from "./Main";
import ScreenSaverControl from './ScreenSaverControl';

import SetTeamsMain from './SetTeamsMain';
import SettingsMain from './SettingsMain';
import EditEventMain from './EditEventMain';
import EditTimeMain from './EditTimeMain';
import GoaliesMain from './GoaliesMain';
import EscapeToHome from './EscapeToHome';

function App() {

  const { setTimer, running, setRunning, theme, FLAGS } = useContext(AppContext);

  // Timer old method
  useEffect(() => {
    let interval;
    if (running) {
      interval = setInterval(() => {
        setTimer(prevTimer => {
          const newTimer = Math.max(prevTimer - 0.1, 0)
          if (newTimer === 0) {
            setRunning(false);
          }
          return (newTimer);
        });
      }, 100);
    }
    return () => clearInterval(interval);
  }, [running, setRunning, setTimer]);

  useEffect(() => {
    const altThemeLink = document.getElementById('alt-theme');
    if (theme === 'default') {
      // disable alt theme
      altThemeLink.disabled = true;
    }
    else if (theme === 'alt-theme') {
      // enable the alt-theme
      altThemeLink.disabled = false;
    }
    localStorage.setItem("hockeyData.theme", JSON.stringify(theme));
  }, [theme]);
  //Hamburger MenuSTuff
  const [hideSettingsWindow, setSettingsWindowVisibility] = useState(false);

  let hideHamburger = () => {
    document.querySelector("#settingsWindow").style.display = "none"
    console.log("hiding hamburger menu");
    setSettingsWindowVisibility(false);
  }

  const toggleVisibility = () => {
    console.log('click on toggleVisibility');
    if (hideSettingsWindow) {
      document.querySelector("#settingsWindow").style.display = "none"
      setSettingsWindowVisibility(false);
      if (FLAGS.debug) { console.log("Hiding Settings Window"); }
    } else {
      document.querySelector("#settingsWindow").style.display = "block"
      setSettingsWindowVisibility(true);
      if (FLAGS.debug) { console.log("Showing Settings Window"); }
    }
  };

  console.log('Running app');

  return (
    <div>
      {/* <ScreenSaverControl FLAGS={FLAGS} /> */}

      <Router future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
        <div id='mainApp'>
          <div id='hamburgerButton' >
            {/* <div id='settingsButton' > */}
            {/* <button id='settingsButton2' >Settings</button> */}
            {/* <div className="hamburger"> |||</div> */}
            <table className='hamburger hamburgerFloat'><tbody><tr>
              <td className='hamburger'><ScreenSaverControl /></td>
              <td onClick={toggleVisibility} className='hamburger'>
                <div className="hamburgerRotated"> |||</div>
              </td></tr></tbody></table>
          </div>
          <div id='settingsWindow' className='fullWindowToggle' >
            <h1>Navigation</h1>
            <nav>
              <ul>
                <li> <Link to="/" onClick={toggleVisibility}> Home</Link> </li>
                <li> <Link to="/editevents" onClick={toggleVisibility}>Edit Events</Link> </li>
                <li> <Link to="/setteamname" onClick={toggleVisibility}>Set Team Names</Link> </li>
                <li> <Link to="/edittime" onClick={toggleVisibility}>Edit Time</Link> </li>
                <li> <Link to="/setgoalie" onClick={toggleVisibility}>Set Goalies</Link> </li>
                <li> <Link to="/settings" onClick={toggleVisibility}>Settings</Link> </li>
                <li> <Link to="/about" onClick={toggleVisibility}>About</Link> </li>
              </ul>
            </nav>
          </div>
          <EscapeToHome />
          <Routes>
            <Route path="/" element={<Main hideHamburger={hideHamburger} />} />
            <Route path="/settings" element={<SettingsMain hideHamburger={hideHamburger} />} />
            <Route path="/setteamname" element={<SetTeamsMain hideHamburger={hideHamburger} />} />
            <Route path="/setgoalie" element={<GoaliesMain hideHamburger={hideHamburger} />} />
            <Route path="/edittime" element={<EditTimeMain hideHamburger={hideHamburger} />} />
            <Route path="/editevents" element={<EditEventMain hideHamburger={hideHamburger} />} />
            <Route path="/editevents" element={<EditEventMain hideHamburger={hideHamburger} />} />
            <Route path="/about" element={<About hideHamburger={hideHamburger} />} />
          </Routes>
        </div>
      </Router>
    </div>
  );
}

export default App

